export enum PaymentStatus {
    pending = "Pending",
    success = "Success",
    failed = "Failed"
}